import TabUnselectedIcon from "@mui/icons-material/TabUnselected";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { ToggleButton, Tooltip } from "@mui/material";
import { StyledToggleButtonGroup } from "features/WorklistTools/shared/components/styles/styled-components";
import { SelectionProcess } from "features/WorklistTools/shared/interfaces";
import React from "react";
import { NucleofectionInternalAction } from "../state/action";
import { useNucleofectionStateProvider } from "../state/StateProvider";

export const SelectionView = () => {
  const { nucleofectionInternalState, nucleofectionDispatch } =
    useNucleofectionStateProvider();

  return (
    <React.Fragment>
      <StyledToggleButtonGroup
        value={nucleofectionInternalState.destSelectionProcess}
        exclusive
        onChange={(e, value) => {
          nucleofectionDispatch({
            type: NucleofectionInternalAction.SET_DEST_SELECTION_PROCESS,
            payload: {
              destSelectionProcess: value,
            },
          });
        }}
      >
        <ToggleButton value={SelectionProcess.Stamp}>
          <Tooltip title="Stamp" placement="right">
            <TabUnselectedIcon style={{ transform: "scaleX(-1)" }} />
          </Tooltip>
        </ToggleButton>
        <ToggleButton value={SelectionProcess.RowWise}>
          <Tooltip title="Row" placement="right">
            <ViewColumnIcon style={{ transform: "rotate(90deg)" }} />
          </Tooltip>
        </ToggleButton>
        <ToggleButton value={SelectionProcess.ColWise}>
          <Tooltip title="Column" placement="right">
            <ViewColumnIcon />
          </Tooltip>
        </ToggleButton>
      </StyledToggleButtonGroup>
    </React.Fragment>
  );
};
